import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { KENYA_ADMIN_MAP } from "../../constants/siteContent";

export const MapDividerSection = ({ testId, mapPosition = "58% 50%" }) => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [90, -90]);

  return (
    <section ref={sectionRef} data-testid={testId} className="relative h-40 overflow-hidden bg-transparent md:h-56">
      <motion.img
        src={KENYA_ADMIN_MAP}
        alt="Scrolling Kenya map divider"
        className="absolute inset-0 h-[210%] w-full object-cover object-[58%_center] opacity-100"
        style={{ y, scale: 1.05, objectPosition: mapPosition }}
      />
    </section>
  );
};